import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {RomanEmpireGameAssets} from "../RomanEmpireGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {RomanEmpire} from "../RomanEmpire";

/**
 * Created by jonas on 2020-03-19.
 */

export class SinglePageIntro extends SlideShowPage {
    leftIcon: PIXI.Sprite;
    centreIcon: PIXI.Sprite;
    rightIcon: PIXI.Sprite;

    constructor() {
        super();

        this.leftIcon = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpire.api.gameClientConfiguration.showLowProbabilityGfx ? RomanEmpireGameAssets.GENIW_WISHES : RomanEmpireGameAssets.GENIW_WISHES_US));
        this.leftIcon.anchor.set(0.5, 0.5);
        this.leftIcon.position.set(0, this.height / 2);
        this.addChild(this.leftIcon);

        this.centreIcon = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpire.api.gameClientConfiguration.showLowProbabilityGfx ? RomanEmpireGameAssets.GENIE_PARADE : RomanEmpireGameAssets.GENIE_PARADE_US));
        this.centreIcon.anchor.set(0.5, 0.5);
        this.centreIcon.position.set(0, this.height / 2 - this.centreIcon.height / 2.4);
        this.addChild(this.centreIcon);


        this.rightIcon = new PIXI.Sprite(ImgLoader.getImgTexture(RomanEmpireGameAssets.GENIE_LAMP));
        this.rightIcon.anchor.set(0.5, 0.5);
        this.rightIcon.position.set(0, this.height / 2 - this.rightIcon.height / 2);
        this.addChild(this.rightIcon);

        NolimitApplication.events.on(NolimitApplication.RESIZE, () => {
        });
    }

    public resize(): void {
        const bounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            this.leftIcon.scale.set(1);
            this.rightIcon.scale.set(1.2);
            this.centreIcon.scale.set(1.4);
            this.leftIcon.x = bounds.left - this.leftIcon.width / 2.7;
            this.centreIcon.x = bounds.center - this.centreIcon.width * 0.9;
            this.rightIcon.x = bounds.right - this.rightIcon.width * 1.7;
            if (bounds.width < 1000) {
                this.leftIcon.x = bounds.left - this.leftIcon.width * 0.8;
                this.centreIcon.x = bounds.center - this.centreIcon.width * 0.9;
                this.rightIcon.x = bounds.right - this.rightIcon.width * 1.6;
            }
        } else {
            this.leftIcon.scale.set(0.8);
            this.rightIcon.scale.set(1);
            this.centreIcon.scale.set(1.1);
            this.leftIcon.x = bounds.left - this.leftIcon.width * 1.1;
            this.centreIcon.x = bounds.center - this.centreIcon.width * 1.1;
            this.rightIcon.x = bounds.right / 1.4 - this.rightIcon.width * 0.9;
        }

    }

}